import React, {useEffect, useState} from "react";
import {Select} from "antd";
import type { CustomTagProps } from 'rc-select/lib/BaseSelect';
import {INGREDIENT_SEARCH, SelectModes} from "src/constants/appConstants";
import {searchBarStyle} from "src/constants/styleConstants";

export function SearchBar(props: { data: JSX.Element[], searchValue: string, searchedValues: string[], onChange: (values: string[]) => void, onSearch: (value: string) => void, placeholder?: string,
    onInputKeyDown: React.KeyboardEventHandler<HTMLInputElement | HTMLTextAreaElement>
    tagRender: (props: CustomTagProps) => React.ReactElement<any, string | React.JSXElementConstructor<any>>
}) {

    const [localSearchValue, setLocalSearchValue] = useState(props.searchValue);

    // Sync local search value with props when it changes
    useEffect(() => {
        setLocalSearchValue(props.searchValue);
    }, [props.searchValue]);

    return <div className={"search-bar"}>
        <Select
            mode={SelectModes.multiple}
            placeholder={localSearchValue||props.placeholder||INGREDIENT_SEARCH}
            style={searchBarStyle}
            value={props.searchedValues}
            onChange={props.onChange}
            onSearch={props.onSearch}
            searchValue={localSearchValue}
            onInputKeyDown={props.onInputKeyDown}
            tagRender={props.tagRender}
            filterOption={false}
            allowClear
            onBlur={() => setLocalSearchValue(props.searchValue)}
            onFocus={() => setLocalSearchValue(props.searchValue)}
        >
            {props.data}
        </Select>
    </div>;
}